import { useTranslation } from 'react-i18next';
import { Input } from '@framework/ui/atoms/Input';
import type { ViewModelSharingUserRoleType } from '@view-model/domain/view-model';
import { ShareDisabledMessage } from './ShareDisabledMessage';
import { ShareSetting } from './ShareSetting';
import { LockSetting } from './LockSetting';

type Props = {
  viewModelURLShareable: boolean;
  isPublicWorkspace: boolean;
  name: string;
  onChangeName(name: string): void;
  sharingUserRole: ViewModelSharingUserRoleType;
  onChangeSharingUserRole(role: ViewModelSharingUserRoleType): void;
  isLocked: boolean;
  onChangeIsLocked(isLocked: boolean): void;
  disabled: boolean;
};

export const SettingForm: React.FC<Props> = ({
  viewModelURLShareable,
  isPublicWorkspace,
  name,
  onChangeName,
  sharingUserRole,
  onChangeSharingUserRole,
  isLocked,
  onChangeIsLocked,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="py-2">
        <div className="pb-2 font-bold">{t('canvas.viewModelSetting.nameLabel')}</div>
        <Input
          type="text"
          placeholder={t('canvas.viewModelSetting.namePlaceholder')}
          value={name}
          onChange={(e) => onChangeName(e.target.value)}
          disabled={disabled}
          autoFocus={true}
        />
      </div>
      <div className="pb-2 pt-6">
        <div className="pb-2 font-bold">{t('canvas.viewModelSetting.lockLabel')}</div>
        <LockSetting isLocked={isLocked} onChange={onChangeIsLocked} disabled={disabled} />
      </div>
      <div className="pb-2 pt-6">
        <div className="pb-2 font-bold">{t('canvas.viewModelSetting.shareLabel')}</div>
        {viewModelURLShareable ? (
          <ShareSetting
            isPublicWorkspace={isPublicWorkspace}
            sharingUserRole={sharingUserRole}
            onChange={onChangeSharingUserRole}
            disabled={disabled}
          />
        ) : (
          <ShareDisabledMessage />
        )}
      </div>
    </>
  );
};
